import { MMButton, SelectAccount } from '@components'
import { findCurrencyPrecision, formatFloat, tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { shallowEqual, useSelector } from 'react-redux'

import './PreviewPane.scss'

const PreviewPane = ({ selectedAccount, handlePay, onCancel }) => {
  const { walletPreview, walletPayError, walletPayFetching } = useSelector(
    ({ checkout: { walletPreview, walletPayError, walletPayFetching } }) => ({
      walletPreview,
      walletPayError,
      walletPayFetching
    }),
    shallowEqual
  )

  const { walletAmount, walletCurrency } = walletPreview || {}

  return (
    <div className='preview-pane-wrapper'>
      <div className='preview-container'>
        <div className='preview-title'>{tr('CHECKOUT.PAYMENT.REVIEW_AND_PAY', 'Review & Pay')}</div>

        <div className='form-fields'>
          <div className='merchant-pane-details-wrapper'>
            <div className='merchant-pane-details-title'>{tr('CHECKOUT.PAYMENT.FROM_ACCOUNT', 'From account')}</div>
            <SelectAccount selectedAccount={selectedAccount} staticDisplay={true} />
          </div>

          {walletAmount ? (
            <div className='merchant-pane-details-wrapper'>
              <div className='merchant-pane-details-title'>{tr('CHECKOUT.PAYMENT.WALLET_AMOUNT', 'Wallet amount')}</div>
              <div className='merchant-pane-details-value'>
                <span className='amount'>{formatFloat(walletAmount, findCurrencyPrecision(walletCurrency))}</span>
                <span className='currency'>{walletCurrency}</span>
              </div>
            </div>
          ) : (
            <div className='merchant-pane-details-wrapper'>
              <div className='merchant-pane-details-title'>{tr('CHECKOUT.PAYMENT.CURRENCY', 'Currency')}</div>
              <div className='merchant-pane-details-value'>{walletCurrency}</div>
            </div>
          )}
        </div>

        <ErrorDisplay error={walletPayError} />

        <div className='form-actions'>
          <MMButton
            type='button'
            variant='primary'
            caption={tr('CHECKOUT.BUTTONS.PAY', 'Pay')}
            onClick={handlePay}
            loading={walletPayFetching}
            data-test='button-submit'
            fullWidth
          />
          <MMButton
            type='button'
            variant='secondary'
            caption={tr('CHECKOUT.BUTTONS.CANCEL', 'Cancel')}
            onClick={onCancel}
            disabled={walletPayFetching}
            data-test='button-back'
            fullWidth
          />
        </div>
      </div>
    </div>
  )
}

export default PreviewPane
